import { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { site } from '@/mocks/manhwa';

const navItems = [
  { label: '首页', target: '/', section: '' },
  { label: '精选必看', target: '/', section: 'featured' },
  { label: '高分人气', target: '/', section: 'trending' },
  { label: '题材书单', target: '/', section: 'genres' },
  { label: '冷门宝藏', target: '/', section: 'gems' },
  { label: '关于我们', target: '/about', section: '' },
];

function scrollToSection(section: string) {
  if (!section) return;
  setTimeout(() => {
    document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 120);
}

function handleNav(item: { label: string; target: string; section: string }) {
  if (item.target === '/about') {
    window.REACT_APP_NAVIGATE('/about');
    return;
  }
  if (window.location.pathname !== '/') {
    window.REACT_APP_NAVIGATE('/');
  }
  scrollToSection(item.section);
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const solid = scrolled || location.pathname !== '/' || open;

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`transition-all duration-300 ${
          solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
        }`}
      >
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
          <Link to="/" className="flex items-center gap-2 group" aria-label="回到首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg" />
            </span>
            <span
              className={`font-heading text-xl font-bold tracking-wide ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              {site.brand}
            </span>
          </Link>

          <ul className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <li key={item.label}>
                <button
                  type="button"
                  onClick={() => handleNav(item)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                    solid
                      ? 'text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950'
                      : 'text-background-50/90 hover:bg-background-50/20 hover:text-background-50'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => handleNav({ label: '', target: '/', section: 'contact' })}
              className={`hidden whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors sm:inline-block ${
                solid
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-900 hover:bg-accent-200'
              }`}
            >
              推荐你的漫画
            </button>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className={`flex h-10 w-10 items-center justify-center rounded-lg md:hidden ${
                solid ? 'text-foreground-900 bg-background-200/70' : 'text-background-50 bg-background-50/15'
              }`}
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
            </button>
          </div>
        </nav>

        {open && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <ul className="space-y-1 px-4 py-3">
              {navItems.map((item) => (
                <li key={item.label}>
                  <button
                    type="button"
                    onClick={() => {
                      setOpen(false);
                      handleNav(item);
                    }}
                    className="w-full rounded-lg px-3 py-2.5 text-left text-sm text-foreground-800 hover:bg-background-200/70"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}